export default __webpack_public_path__ + "static/media/Poppinspoppins-semiboldmedium.871297ae.woff2";